import {blockMeta} from '../meta'

export const meta = blockMeta({
  name: 'global',
  displayName: 'GlobalBlock',
  title: 'Global', // just for storybook
})
